// extracted by mini-css-extract-plugin
export default {"enrolledIcon":"FeatureIcon-module__enrolledIcon--DH4KW"};